class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);

    // Selecting elements
    const btnFilters = document.querySelector(".btn-filters");
    const btnFiltersHide = document.querySelector(".btn-filters-hide");
    const drawer = document.querySelector("aside");

    function openDrawer() {
      drawer.classList.remove("aside-close");
      btnFilters.style = "display: none";
      btnFiltersHide.style = "display: flex";
    }

    function closeDrawer() {
      drawer.classList.add("aside-close");
      btnFilters.style = "display: flex";
      btnFiltersHide.style = "display: none";
    }

    btnFilters.addEventListener("click", () => openDrawer());
    btnFiltersHide.addEventListener("click", () => closeDrawer());
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    // document get element by id and class
    const targetElement = document.getElementsByClassName(event.target.id)?.[0];
    if (targetElement) {
      if (targetElement.id.includes("Filter-filter.p.t.category")) {
        console.log("category", targetElement);
        if (event.srcElement.checked) {
          targetElement.nextElementSibling.classList.add(
            "facet-checkbox__text__active"
          );
        } else {
          targetElement.nextElementSibling.classList.remove(
            "facet-checkbox__text__active"
          );
        }
      }

      if (event.srcElement.checked) {
        targetElement.setAttribute("checked", "checked");
      } else {
        targetElement.removeAttribute("checked");
      }
    }
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form")?.id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.minNumberInput = document.getElementById("price-range-number-min");
    this.maxNumberInput = document.getElementById("price-range-number-max");
    this.minSliderInput = document.getElementById("price-range-slider-min");
    this.maxSliderInput = document.getElementById("price-range-slider-max");
    this.minValue = Number(this.minNumberInput.min);
    this.maxValue = Number(this.maxNumberInput.max);

    this.minNumberInputMobile = document.getElementById(
      "price-range-number-min-mobile"
    );
    this.maxNumberInputMobile = document.getElementById(
      "price-range-number-max-mobile"
    );
    this.minSliderInputMobile = document.getElementById(
      "price-range-slider-min-mobile"
    );
    this.maxSliderInputMobile = document.getElementById(
      "price-range-slider-max-mobile"
    );
    this.minValueMobile = Number(this.minNumberInputMobile.min);
    this.maxValueMobile = Number(this.maxNumberInputMobile.max);

    this.timeout = null;
    this.addEventListener("input", this.handleInput.bind(this));
  }

  /**
   * Handles 'input' events on the price range component.
   * @param {object} evt - Event object.
   */
  handleInput(evt) {
    if (evt.detail !== undefined) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.updateSliderInputs(evt);
        this.updateNumberInputs();
      }, 500);
    } else {
      this.updateSliderInputs(evt);
      this.updateNumberInputs();
    }
  }

  /**
   * Updates the value of the 'number' type inputs.
   */
  updateNumberInputs() {
    this.minNumberInput.value =
      this.minSliderInput.value !== this.minNumberInput.min
        ? this.minSliderInput.value
        : null;

    this.maxNumberInput.value =
      this.maxSliderInput.value !== this.maxNumberInput.max
        ? this.maxSliderInput.value
        : null;

    this.minNumberInputMobile.value =
      this.minSliderInputMobile.value !== this.minNumberInputMobile.min
        ? this.minSliderInputMobile.value
        : null;

    this.maxNumberInputMobile.value =
      this.maxSliderInputMobile.value !== this.maxNumberInputMobile.max
        ? this.maxSliderInputMobile.value
        : null;
  }

  /**
   * Updates the value of the 'range' type inputs.
   * @param {object} evt - Event object.
   */
  updateSliderInputs(evt) {
    const minValue = parseInt(this.minNumberInput.value, 10);
    const maxValue = parseInt(this.maxNumberInput.value, 10);

    if (minValue > maxValue - 10) {
      if (evt.target === this.minNumberInput) {
        this.maxSliderInput.value = minValue + 10;

        if (maxValue === this.maxValue) {
          this.minSliderInput.value = this.maxValue - 10;
        }
      } else {
        this.minSliderInput.value = maxValue - 10;
      }
    }

    if (maxValue < minValue + 10) {
      if (evt.target === this.maxNumberInput) {
        this.minSliderInput.value = maxValue - 10;

        if (minValue === this.minValue) {
          this.maxSliderInput.value = 10;
        }
      } else {
        this.maxSliderInput.value = minValue + 10;
      }
    }

    if (evt.target === this.minNumberInput) {
      this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
    }

    if (evt.target === this.maxNumberInput) {
      this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
    }

    const maxPossibleValue = this.maxSliderInput.max;
    const currentMinPercentage =
      (this.minSliderInput.value / maxPossibleValue) * 100;
    const currentMaxPercentage =
      (this.maxSliderInput.value / maxPossibleValue) * 100;
    this.maxSliderInput.style.background = "transparent";

    this.minSliderInput.style.background = `linear-gradient(to right, #c4c4c4 0% ${
      currentMinPercentage - 0.4
    }%, #202020 ${
      currentMinPercentage - 0.4
    }% ${currentMaxPercentage}%, #c4c4c4 ${currentMaxPercentage}% 100%)`;

    // Mobile
    const minValueMobile = parseInt(this.minNumberInputMobile.value, 10);
    const maxValueMobile = parseInt(this.maxNumberInputMobile.value, 10);

    if (minValueMobile > maxValueMobile - 10) {
      if (evt.target === this.minNumberInputMobile) {
        this.maxSliderInputMobile.value = minValueMobile + 10;

        if (maxValueMobile === this.maxValueMobile) {
          this.minSliderInputMobile.value = this.maxValueMobile - 10;
        }
      } else {
        this.minSliderInputMobile.value = maxValueMobile - 10;
      }
    }

    if (maxValueMobile < minValueMobile + 10) {
      if (evt.target === this.maxNumberInputMobile) {
        this.minSliderInputMobile.value = maxValueMobile - 10;

        if (minValueMobile === this.minValueMobile) {
          this.maxSliderInputMobile.value = 10;
        }
      } else {
        this.maxSliderInputMobile.value = minValueMobile + 10;
      }
    }

    if (evt.target === this.minNumberInputMobile) {
      this.minSliderInputMobile.value =
        minValueMobile || Number(this.minNumberInputMobile.min);
    }

    if (evt.target === this.maxNumberInputMobile) {
      this.maxSliderInputMobile.value =
        maxValueMobile || Number(this.maxNumberInputMobile.max);
    }

    const maxPossibleValueMobile = this.maxSliderInputMobile.max;
    const currentMinPercentageMobile =
      (this.minSliderInputMobile.value / maxPossibleValueMobile) * 100;
    const currentMaxPercentageMobile =
      (this.maxSliderInputMobile.value / maxPossibleValueMobile) * 100;
    this.maxSliderInputMobile.style.background = "transparent";

    this.minSliderInputMobile.style.background = `linear-gradient(to right, #c4c4c4 0% ${
      currentMinPercentageMobile - 0.4
    }%, #202020 ${
      currentMinPercentageMobile - 0.4
    }% ${currentMaxPercentageMobile}%, #c4c4c4 ${currentMaxPercentageMobile}% 100%)`;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
